<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Events Gallary</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Events Gallary</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->